//lib
import { Icon } from "@iconify/react/dist/iconify.js";

//redux
import { useSelector } from "react-redux";

//component
import Col from "../element/col";
import Row from "../element/row";
import Image from "../element/image";
import { Logo, Sample } from "../../assets/images";
import Button from "../element/button";
import ArrowButton from "./common.arrow.button";
import Container from "../element/container";

export default function CommonFeature({ className }) {
  const { featureList } = useSelector((state) => state.home);

  return (
    <Container className={`common-feature ${className ?? ""}`}>
      <Row className="_row feature-list">
        {featureList.map((feature, featureIndex) => (
          <Col className="_col feature-item" key={featureIndex}>
            <article className="feature-bg">
              <Image className="_img" src={feature.image} />
            </article>
            <Col className="col-center gap-2">
              <h6 className="_label feature-title">{feature.label}</h6>
              <p className="_label feature-subtitle">{feature.description}</p>
            </Col>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
